import { render, staticRenderFns } from "./DevSessionsIndex.vue?vue&type=template&id=a54cd11a&scoped=true&"
import script from "./DevSessionsIndex.vue?vue&type=script&lang=js&"
export * from "./DevSessionsIndex.vue?vue&type=script&lang=js&"
import style0 from "./DevSessionsIndex.vue?vue&type=style&index=0&id=a54cd11a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54cd11a",
  null
  
)

export default component.exports